var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4541 14.6532H2.67669C1.20451 14.6532 0 13.4488 0 11.9768V2.67638C0 1.20437 1.20451 0 2.67669 0H14.4541C15.9263 0 17.1308 1.20437 17.1308 2.67638V5.21889H16.0602V2.67638C16.0602 1.80656 15.3241 1.07054 14.4541 1.07054H2.67669C1.80677 1.07054 1.07066 1.80656 1.07066 2.67638V11.9768C1.07066 12.8466 1.80677 13.5826 2.67669 13.5826H14.4541C15.3241 13.5826 16.0602 12.8466 16.0602 11.9768V9.50112H17.1308V11.9768C17.1308 13.5157 15.9263 14.6532 14.4541 14.6532Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1924 10.1034H10.7052C9.76837 10.1034 8.89844 9.23364 8.89844 8.29692V6.55723C8.89844 5.62051 9.76837 4.75073 10.7052 4.75073H16.1924C17.1292 4.75073 17.9992 5.62051 17.9992 6.55723V8.29692C17.9992 9.23364 17.1292 10.1034 16.1924 10.1034ZM10.7052 5.82125C10.3037 5.82125 9.9691 6.15578 9.9691 6.55723V8.29692C9.9691 8.69837 10.3037 9.0329 10.7052 9.0329H16.1924C16.5939 9.0329 16.9285 8.69837 16.9285 8.29692V6.55723C16.9285 6.15578 16.5939 5.82125 16.1924 5.82125H10.7052Z",
    fill: "#404040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2424 7.9623C11.1085 7.9623 10.9077 7.82845 10.8408 7.76154C10.707 7.76154 10.707 7.56081 10.707 7.42699C10.707 7.29317 10.707 7.09246 10.8408 7.02555C11.0416 6.82482 11.3762 6.82482 11.5769 7.02555C11.7108 7.15937 11.7777 7.22626 11.7777 7.42699C11.7777 7.56081 11.6439 7.76154 11.5769 7.76154C11.4431 7.82845 11.3762 7.9623 11.2424 7.9623Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1b3d063262667f1f46862fcdce954db5.svg";
export { ForwardRef as ReactComponent };